import './PageCompteResultat.css';


function PageCompteResultat() {
    return (
        <h1>PageCompteResultat</h1>
    );
}

export default PageCompteResultat

